import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import CardActions from "@mui/joy/CardActions";
import Button from "@mui/joy/Button";
import React, {useState} from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import MenuItem from "@mui/material/MenuItem";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';


const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];

const PrintModal = () => {
    const [favoritePet1, setFavoritePet1] = useState('dog');
    const [favoritePet2, setFavoritePet2] = useState('cat');
    const [favoritePet3, setFavoritePet3] = useState('fish');

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log('Selected Pets:', { favoritePet1, favoritePet2, favoritePet3 });
        // Here, you can add logic to send form data to a server or perform other actions
    };

    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === steps.length ? (
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Reset</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <>
                        <CardContent sx={{maxWidth: '40ch'}}>
                            Create a public view link to allow anyone to access a view-only version of this design, no
                            sign-in required.
                        </CardContent>
                        <form style={{width:'100%'}} onSubmit={handleSubmit}>
                            <FormControl sx={{ width: 240, mb: 2 }}>
                                <FormLabel id="select-field-1-label" htmlFor="select-field-1-button">
                                    Favorite pet 1
                                </FormLabel>
                                <Select
                                    value={favoritePet1}
                                    onChange={(e) => setFavoritePet1(e.target.value)}
                                    defaultValue="dog"
                                    slotProps={{
                                        button: {
                                            id: 'select-field-demo-button',
                                            // TODO: Material UI set aria-labelledby correctly & automatically
                                            // but Base UI and Joy UI don't yet.
                                            'aria-labelledby': 'select-field-demo-label select-field-demo-button',
                                        },
                                    }}
                                >
                                    <Option value="dog">Dog</Option>
                                    <Option value="cat">Cat</Option>
                                    <Option value="fish">Fish</Option>
                                    <Option value="bird">Bird</Option>
                                </Select>
                                <FormHelperText id="select-field-1-helper">
                                    This is a helper text for the first select.
                                </FormHelperText>
                            </FormControl>
                            <FormControl sx={{ width: 240, mb: 2 }}>
                                <FormLabel id="select-field-2-label" htmlFor="select-field-2-button">
                                    Favorite pet 2
                                </FormLabel>
                                <Select
                                    value={favoritePet2}
                                    onChange={(e) => setFavoritePet2(e.target.value)}
                                    defaultValue="dog"
                                    slotProps={{
                                        button: {
                                            id: 'select-field-demo-button',
                                            'aria-labelledby': 'select-field-demo-label select-field-demo-button',
                                        },
                                    }}
                                >
                                    <Option value="dog">Dog</Option>
                                    <Option value="cat">Cat</Option>
                                    <Option value="fish">Fish</Option>
                                    <Option value="bird">Bird</Option>
                                </Select>
                                <FormHelperText id="select-field-2-helper">
                                    This is a helper text for the second select.
                                </FormHelperText>
                            </FormControl>
                            <FormControl sx={{ width: 240, mb: 2 }}>
                                <FormLabel id="select-field-3-label" htmlFor="select-field-3-button">
                                    Favorite pet 3
                                </FormLabel>
                                <Select
                                    value={favoritePet3}
                                    onChange={(e) => setFavoritePet3(e.target.value)}
                                    defaultValue="dog"
                                    slotProps={{
                                        button: {
                                            id: 'select-field-demo-button',
                                            'aria-labelledby': 'select-field-demo-label select-field-demo-button',
                                        },
                                    }}
                                >
                                    <Option value="dog">Dog</Option>
                                    <Option value="cat">Cat</Option>
                                    <Option value="fish">Fish</Option>
                                    <Option value="bird">Bird</Option>
                                </Select>
                                <FormHelperText id="select-field-3-helper">
                                    This is a helper text for the third select.
                                </FormHelperText>
                            </FormControl>
                            <Button variant="contained" type="submit">
                                Submit
                            </Button>
                        </form>
                    </>
                    <Typography>Step {activeStep + 1}</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            Back
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />

                        <Button onClick={handleNext}>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    )
}
export default PrintModal